import { ReactComponent as FolderIcon } from '../assets/icons/folder.svg';
import { ReactComponent as LogoIcon } from '../assets/icons/Logo.svg';
import { ReactComponent as ChartIcon } from '../assets/icons/pie-chart.svg';
import { ReactComponent as SettingsIcon } from '../assets/icons/settings-1.svg';
import { ReactComponent as SettingsAltIcon } from '../assets/icons/settings.svg';
import { ReactComponent as HouseIcon } from '../assets/icons/house.svg';
import { ReactComponent as CancelIcon } from '../assets/icons/cancel.svg';
import { ReactComponent as GoogleIcon } from '../assets/icons/google-icon.svg';

const iconsTypes = {
  FolderIcon,
  LogoIcon,
  ChartIcon,
  SettingsAltIcon,
  SettingsIcon,
  HouseIcon,
  CancelIcon,
  GoogleIcon,
};

export default iconsTypes;
